import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { apiRequest } from "@/config/api";
import {
  clearCurrentAuthSession,
  clearImpersonationSession,
  getImpersonationEventName,
  getImpersonationSession
} from "@/utils/impersonation";

const ImpersonationReturnButton = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const refresh = () => setVersion((prev) => prev + 1);
    const eventName = getImpersonationEventName();
    window.addEventListener(eventName, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(eventName, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  const session = useMemo(() => {
    void version;
    return getImpersonationSession();
  }, [version]);

  if (!session) return null;

  const handleReturnToAdmin = async () => {
    setLoading(true);
    const currentToken = localStorage.getItem("token");
    try {
      if (currentToken) {
        await apiRequest("/auth/logout", {
          method: "POST",
          headers: { Authorization: `Bearer ${currentToken}` }
        });
      }
    } catch {
      // A limpeza local precisa acontecer mesmo com falha de rede
    } finally {
      clearCurrentAuthSession();
      clearImpersonationSession();
      navigate("/login", { replace: true });
      setLoading(false);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-[70]">
      <Button
        onClick={handleReturnToAdmin}
        disabled={loading}
        className="bg-[#F87C5D] text-white shadow-lg hover:bg-[#e66f53]"
      >
        {loading ? "Retornando..." : "Voltar ao Admin"}
      </Button>
    </div>
  );
};

export default ImpersonationReturnButton;
